// extracted by mini-css-extract-plugin
export default {"customScrollbar":"AgentCommonLayout_customScrollbar__9tScB"};